import { styled as muiStyled } from '@mui/material'

export const PlannedActivityStartedButtonsContainer = muiStyled('div')(
  ({ theme }) => `
display: flex;
justify-content: center;
width: 100%;
align-items: center;
// gap: 10px;
flex-direction: column;
background: #e1e1e1b3;
aspect-ratio: 16/9;
padding: 0 20px;
box-shadow: 0px 0px 10px 0px #0000001a;
border-radius: 10px;
.or-text {
  color :#000;
}
// @media (min-width: 576px){
//   flex-direction: row;
// }
`,
)

export const UAPBegunActivityStepsContainer = muiStyled('div')(
  ({ theme }) => `
  z-index: 3;
    display: flex;
    color: white;
    flex-direction: column;
    max-width: 482px;
    margin: 0 auto;
    width: 100%;
    padding: 0px 14px;
    .step-text {
        font-size: 16px;
        font-weight: 500;
    }
`,
)

export const UAPBegunActivityStepItemsContainer = muiStyled('div')(
  ({ theme, disabled }) => `
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;
      pointer-events: ${disabled ? 'none' : 'auto'};

      .activity-step-item {
      filter: ${disabled ? 'brightness(0.3)' : 'none'};
      }
      .step-text {
        filter: ${disabled ? 'brightness(0.3)' : 'none'};
      }
`,
)

export const UAPBegunActivityStepIndicator = muiStyled('div')(
  ({ theme, completed, disabled }) => `
  aspect-ratio: 1;
  width: 24px;
  background: ${completed ? '#00cd21' : '#fff'};
  border-radius: 50px;
  flex-shrink: 0;
  filter: ${disabled ? 'brightness(0.3)' : 'none'};
  display: flex;
  justify-content: center;
  align-items: center;
  
`,
)
export const UAPBegunActivityStepIndicatorLine = muiStyled('div')(
  ({ theme, completed, disabled }) => `
  background: ${completed ? '#00cd21' : '#fff'};
  border-left: 4px ${completed ? 'solid #00cd21' : 'solid #fff'};
  filter: ${disabled ? 'brightness(0.3)' : 'none'};
  margin-top: -2px;
  height: 100%;
  overflow: hidden;
`,
)
